import styles from './FolderItemVideo.module.scss';
import React, { MouseEvent } from 'react';
import { timeToColonTimeCode } from '@he-novation/lib-timecodes';

type FolderItemFileVideoProps = {
    item: {
        thumbnail?: string;
        preview?: string;
        duration?: number;
    };
    noDuration?: boolean;
};
const onVideoMouseMove = (e: MouseEvent<HTMLVideoElement>) => {
    const video = e.currentTarget;

    if (video?.duration) {
        const rect = video.getBoundingClientRect();
        const perOne = (e.clientX - rect.left) / rect.width;
        video.currentTime = perOne * video.duration;
        (e.currentTarget.parentNode!.querySelector('.video-time') as HTMLDivElement).style.left =
            `${perOne * 100}%`;
    }
};

const onVideoMouseLeave = (e: MouseEvent<HTMLVideoElement>) => {
    e.currentTarget.currentTime = 0;
    e.currentTarget.load();
};

const formatDuration = (duration: string) => duration.replace(/\..*/, '').replace(/^00?:/, '');

export function FolderItemVideo({ item, noDuration }: FolderItemFileVideoProps) {
    return item.preview ? (
        <>
            {!noDuration && item?.duration && (
                <span className={styles.duration}>
                    {formatDuration(timeToColonTimeCode(item.duration / 1000))}
                </span>
            )}
            <video
                src={item.preview}
                poster={item.thumbnail || undefined}
                preload="none"
                onMouseOver={(e) => {
                    e.currentTarget.preload = 'metadata';
                }}
                onMouseMove={onVideoMouseMove}
                onMouseLeave={onVideoMouseLeave}
            />
            <span className="video-time" />
        </>
    ) : (
        <img src={item.thumbnail || undefined} alt="" />
    );
}
